<template>
  <mini-urne />
</template>

<script>
import MiniUrne from '../components/KeuzesUitvaart/MiniUrne.vue'

export default {
  name: 'MiniUrneView',
  components: {
    MiniUrne
  }
}
</script>
